<template>
    <section class="paint-real-wrapper">
        <span class="real-top-span">Nasze realizacje</span>
        <div class="real-section">
            <div class="sec-img real-scaff-img1"></div>
            <article class="sec-text">
                <div class="shape"></div>
                <div class="shape"></div>
                <span class="real-span1">Lorem ipsum dolor sit amet consectetur.</span>
                <span class="real-span2">Lorem ipsum dolor sit amet consectetur adipisicing elit. Beatae, pariatur
                    laudantium? Ducimus temporibus recusandae dolore sint perspiciatis cum quos tenetur odio consequatur sit
                    consectetur perferendis qui saepe quisquam minima repellat, sed obcaecati veniam.</span>
                <span class="real-span2">Lorem ipsum dolor sit amet consectetur adipisicing elit. Accusamus dicta distinctio
                    repellendus reprehenderit provident?</span>
            </article>
        </div>
        <!-- <div class="real-section">
            <article class="sec-text">
                <div class="shape"></div>
                <div class="shape"></div>
                <span class="real-span1">Lorem ipsum dolor sit amet consectetur.</span>
                <span class="real-span2">Lorem ipsum dolor sit amet consectetur adipisicing elit. Beatae, pariatur
                    laudantium? Ducimus
                    temporibus recusandae dolore sint perspiciatis cum quos tenetur odio consequatur sit consectetur
                    perferendis qui
                    saepe quisquam minima repellat, sed obcaecati veniam.</span>
                <span class="real-span2">Lorem ipsum dolor sit amet consectetur adipisicing elit. Accusamus dicta distinctio
                    repellendus
                    reprehenderit provident?</span>
            </article>
            <div class="sec-img real-scaff-img2"></div>
        </div>
        <div class="real-section">
            <div class="sec-img real-scaff-img3"></div>
            <article class="sec-text">
                <div class="shape"></div>
                <div class="shape"></div>
                <span class="real-span1">Lorem ipsum dolor sit amet consectetur.</span>
                <span class="real-span2">Lorem ipsum dolor sit amet consectetur adipisicing elit. Beatae, pariatur
                    laudantium? Ducimus
                    temporibus recusandae dolore sint perspiciatis cum quos tenetur odio consequatur sit consectetur
                    perferendis qui
                    saepe quisquam minima repellat, sed obcaecati veniam.</span>
                <span class="real-span2">Lorem ipsum dolor sit amet consectetur adipisicing elit. Accusamus dicta distinctio
                    repellendus
                    reprehenderit provident?</span>
            </article>
        </div> -->
    </section>
</template>

<script>
export default {
    name: 'scaffolding-real',
}
</script>

<style lang="scss">
.real-scaff-img1 {
    background-image: url('../../../public/img/scaffolding/3.jpg');
}
.real-scaff-img2 {
    background-image: url('../../../public/img/painting_top_section1.jpg');
}
.real-scaff-img3 {
    background-image: url('../../../public/img/painting_top_section1.jpg');
}
</style>